import React from 'react';
import { Box, Typography, Stack, Checkbox } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function CategoryEntry({ category: cat, isSelected, toggleCategory, color}) {
    const theme = useTheme();

    return (
        <Stack direction="row" alignItems="center" spacing={0.5}>
            <Checkbox
                checked={isSelected}
                onChange={() => toggleCategory(cat)}
            />
            <Box
                px={1.5}
                py={0.5}
                sx={{
                    backgroundColor: color,
                    borderRadius: 1,
                    display: 'inline-block'
                }}
            >
                <Typography 
                    variant="normal" 
                    sx={{ 
                        fontSize: '14px',
                        color: theme.palette.background.white
                    }}
                >
                    {cat}
                </Typography>
            </Box>
        </Stack>
    );
}

export default CategoryEntry;